<template>
  <Switch
    :checked="checked"
    class="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
    @update:model-value="onToggle"
  >
    <span class="sr-only">{{ srLabel }}</span>
    <span
      aria-hidden="true"
      class="pointer-events-none absolute h-full w-full rounded-md bg-white"
    ></span>
    <span
      aria-hidden="true"
      :class="[
        checked
          ? 'bg-indigo-600 group-disabled:bg-indigo-300'
          : 'bg-gray-200 group-disabled:bg-gray-200',
        'pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out',
      ]"
    ></span>
    <span
      aria-hidden="true"
      :class="[
        checked ? 'translate-x-5' : 'translate-x-0',
        'pointer-events-none absolute left-0 inline-block h-5 w-5 rounded-full border border-gray-200 bg-white ring-0 shadow-sm transition-transform duration-200 ease-in-out',
      ]"
    ></span>
  </Switch>
</template>

<script setup>
import { Switch } from '@headlessui/vue'

defineProps(['checked', 'srLabel', 'onToggle'])
</script>
